var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "login-service-container"
  }, [_c("div", {
    staticClass: "login-service-container__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c("div", {
    staticClass: "login-service-container__service__title"
  }, [_vm._v("您可享受以下服务：")]), _vm._l(_vm.serviceList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "login-service-container__service__item"
    }, [_c("img", {
      attrs: {
        src: require(`@/assets/images/${item.icon}`),
        alt: "img"
      }
    }), _c("section", {
      staticClass: "item-content"
    }, [_c("div", {
      staticClass: "header"
    }, [_vm._v(_vm._s(item.header))]), _c("div", {
      staticClass: "desc"
    }, [_vm._v(_vm._s(item.desc))])])]);
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };